import replace from 'lodash/replace';

import {TemplateRCDataFromRequest, TransformRCData} from 'core/RateConfirmation/types';

import {getTranslateSomeTitle, isRegionNA} from '../translate';
import {getAddressLine} from '../address';

export const getTransformDataToTemplate = (data: TemplateRCDataFromRequest): TransformRCData => {
    const titleTravelOrder = getTranslateSomeTitle({data, translateTitle: 'Travel Order No.:'});
    const titleLoad = getTranslateSomeTitle({data, translateTitle: 'Our Pro No.:'});
    const titleTableStop = getTranslateSomeTitle({data, translateTitle: 'STOP'});
    const titleTableTime = getTranslateSomeTitle({data, translateTitle: 'Time'});
    const titleTableDetails = getTranslateSomeTitle({data, translateTitle: 'Details'});
    const titleStopType = getTranslateSomeTitle({data, translateTitle: 'Type:'});
    const titleStopFrom = getTranslateSomeTitle({data, translateTitle: 'From:'});
    const titleStopTo = getTranslateSomeTitle({data, translateTitle: 'To:'});
    const titleStopTime = getTranslateSomeTitle({data, translateTitle: 'Time:'});
    const titleStopBy = getTranslateSomeTitle({data, translateTitle: 'By:'});
    const titleStackable = getTranslateSomeTitle({data, translateTitle: 'Stackable:'});
    const titleHazmat = getTranslateSomeTitle({data, translateTitle: 'Hazmat:'});
    const titleNote = getTranslateSomeTitle({data, translateTitle: 'Note:'});
    const titleWithFax = getTranslateSomeTitle({
        data,
        translateTitle: 'Please fax back the signed copy to fax no: <strong>%fax%</strong>',
    });
    const titleWithoutFax = getTranslateSomeTitle({
        data,
        translateTitle: 'Please fax back the signed copy or reply to email you received it from.',
    });
    const titleThanks = getTranslateSomeTitle({data, translateTitle: 'Thank you'});
    const titleServiceRequirements = getTranslateSomeTitle({data, translateTitle: 'Service Requirements:'});
    const titlePayment = getTranslateSomeTitle({data, translateTitle: 'For Payment'});
    const titleWarning = getTranslateSomeTitle({
        data,
        translateTitle:
            'It is necessary to inform about the arrival at loading and unloading within 10 minutes. The contractual penalty for the delay in the notification is EUR 50 (separately for loading and unloading) The notification is to be made at Trans ID: 1043648-10 or by e-mail: loads@deltaexpresseu.com',
    });
    const titleAddress = getTranslateSomeTitle({data, translateTitle: 'Address:'});
    const titlePhone = getTranslateSomeTitle({data, translateTitle: 'Phone Number:'});
    const titleBlockCarrier = getTranslateSomeTitle({data, translateTitle: 'Carrier'});
    const titleNip = getTranslateSomeTitle({data, translateTitle: 'Nip:'});
    const titleMailingAddress = getTranslateSomeTitle({data, translateTitle: 'Mailing address:'});
    const titleFax = getTranslateSomeTitle({data, translateTitle: 'Fax:'});

    const titleBlockDriver = getTranslateSomeTitle({data, translateTitle: 'Driver details'});
    const titleDriverName = getTranslateSomeTitle({data, translateTitle: 'Driver’s Name:'});
    const titleDriverPhone = getTranslateSomeTitle({data, translateTitle: 'Driver’s Phone:'});
    const titleSize = getTranslateSomeTitle({data, translateTitle: 'Vehicle size:'});
    const titleNumber = getTranslateSomeTitle({data, translateTitle: 'Vehicle No:'});
    const titleBlockRate = getTranslateSomeTitle({data, translateTitle: 'Total details'});
    const titleDesc = getTranslateSomeTitle({data, translateTitle: 'Authorized Signature:'});
    const titlePieces = getTranslateSomeTitle({data, translateTitle: 'Pieces:'});
    const titleWeight = getTranslateSomeTitle({data, translateTitle: 'Weight:'});
    const titleRate = getTranslateSomeTitle({data, translateTitle: 'Rate:'});

    const titleBlock = getTranslateSomeTitle({data, translateTitle: 'This notification was sent by:'});
    const titleName = getTranslateSomeTitle({data, translateTitle: 'Name:'});
    const titleDate = getTranslateSomeTitle({data, translateTitle: 'Date:'});
    const titleTime = getTranslateSomeTitle({data, translateTitle: 'Time:'});

    const {fax} = data.current_carrier;
    const compiledTitle = replace(`${titleWithFax}`, '%fax%', `${fax}`);

    const {
        rc_carrier_data,
        rc_carrier_data: {address, additional_address, city, state, zip, country},
        current_carrier,
        current_carrier: {
            billing_address_line,
            billing_additional_address_line,
            billing_city,
            billing_state,
            billing_zip,
            billing_country,
            mailing_address_line,
            mailing_additional_address_line,
            mailing_city,
            mailing_zip,
            mailing_country,
            mailing_state,
        },
        serviceAlert,
    } = data;

    const currentCarrierAddress = getAddressLine({
        address: billing_address_line,
        additionalAddress: billing_additional_address_line,
        city: billing_city,
        state: billing_state,
        zip: billing_zip,
        country: billing_country,
    });

    const currentCarrierMailingAddress = getAddressLine({
        address: mailing_address_line,
        additionalAddress: mailing_additional_address_line,
        city: mailing_city,
        state: mailing_state,
        zip: mailing_zip,
        country: mailing_country,
    });

    const rcCarrierAddress = getAddressLine({
        address,
        additionalAddress: additional_address,
        city,
        state,
        zip,
        country,
    });

    const main = {
        titleBlock,
        name: {
            title: titleName,
            value: data?.dispatcher_name,
        },
        date: {
            title: titleDate,
            value: data.rc_date,
        },
        time: {
            title: titleTime,
            value: data.rc_time,
        },
    };

    const stopsData = data.stop_data.map((stop) => {
        const addressFacility = `${stop.shipper_address} ${stop.shipper_city_line}`;
        const freights = stop.freight_data?.map((freight) => {
            return {
                psc: freight.freight_string,
                weight: freight.dims_string,
                stackable: {
                    title: titleStackable,
                    value: freight.is_stackable,
                },
                hazmat: {
                    title: titleHazmat,
                    value: freight.is_hazmat,
                },
            };
        });

        return {
            stopName: stop.stop_name,
            facility: stop.shipper_name,
            facilityAddress: addressFacility,
            timeType: {
                title: titleStopType,
                value: stop.stop_time_type,
            },
            timeFrom: {
                title: titleStopFrom,
                value: stop.time_from,
            },
            timeTo: {
                titleTo: titleStopTo,
                titleTime: titleStopTime,
                titleBy: titleStopBy,
                value: stop.time_to,
            },
            freights,
            dispatcherNote: {
                title: titleNote,
                value: stop.dispatcher_note,
            },
        };
    });
    const isNATemplateData = isRegionNA(data);

    return {
        travelOrder: {
            title: titleTravelOrder,
            value: data.toNumber,
        },
        loadNumber: {
            title: titleLoad,
            value: data.loadNumber,
        },
        titles: {
            stop: titleTableStop,
            time: titleTableTime,
            details: titleTableDetails,
        },
        stopsData,
        fax,
        titleWithFax: compiledTitle,
        titleWithoutFax,
        titleThanks,
        requirements: {
            titleWarning,
            serviceRequirements: {
                title: titleServiceRequirements,
                requirementsNote: data.serviceRequirementsNote,
            },
            payment: {
                title: titlePayment,
                paymentNote: data.forPaymentNote,
            },
        },
        rcCarrier: {
            titleBlock: titleBlockCarrier,
            name: rc_carrier_data.company_name,
            address: {
                title: titleAddress,
                value: rcCarrierAddress,
            },
            phone: {
                title: titlePhone,
                value: rc_carrier_data.phone,
            },
        },
        currentCarrier: {
            companyName: current_carrier?.company_name,
            nip: {
                title: titleNip,
                value: current_carrier?.nip_number,
            },
            address: {
                title: titleAddress,
                value: currentCarrierAddress,
            },
            mailingAddress: {
                title: titleMailingAddress,
                value: currentCarrierMailingAddress,
            },
            phone: {
                title: titlePhone,
                value: current_carrier.phone,
            },
            fax: {
                title: titleFax,
                value: current_carrier.fax,
            },
            email: current_carrier?.email,
        },
        driverInfo: {
            titleBlock: titleBlockDriver,
            name: {
                title: titleDriverName,
                value: data.driver_name,
            },
            phone: {
                title: titleDriverPhone,
                value: data.driver_phone,
            },
            vehicleSize: {
                title: titleSize,
                value: data.truck_size,
            },
            vehicleNumber: {
                title: titleNumber,
                value: data.truck_number,
            },
        },
        totalRate: {
            titleBlock: titleBlockRate,
            titleDesc,
            pieces: {
                title: titlePieces,
                value: data.total_pieces,
            },
            weight: {
                title: titleWeight,
                value: data.total_weights,
            },
            rate: {
                title: titleRate,
                value: data.payment_rate,
            },
        },
        mainInfo: isNATemplateData ? main : undefined,
        serviceAlert: serviceAlert || null,
    };
};
